import { render, staticRenderFns } from "./MallProductPickerDialog.vue?vue&type=template&id=bc635af2&scoped=true"
import script from "./MallProductPickerDialog.vue?vue&type=script&lang=js"
export * from "./MallProductPickerDialog.vue?vue&type=script&lang=js"
import style0 from "./MallProductPickerDialog.vue?vue&type=style&index=0&id=bc635af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc635af2",
  null
  
)

export default component.exports